import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaCheck, FaLock } from "react-icons/fa";
import AstrologerOnboardingLayout from "../components/AstrologerOnboardingLayout";
import AstrologerMarketingPanel from "../components/AstrologerMarketingPanel";
import AstrologerProgress from "../components/AstrologerProgress";
import { TokenWithDeleteUpadateAdd, clearAuthData, getStoredAuthData } from "../utils/api";
import { formatIndianPhoneNumber } from "../utils/phone";
import { toastifyError } from "../utils/toast";
import logo from "../assets/logo";

export default function AstrologerPersonalInfo() {
  const navigate = useNavigate();
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const auth = getStoredAuthData();
  const verifiedMobile = auth?.MobileNo || auth?.Mobile || "";

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [popupStatus, setPopupStatus] = useState(false);
  const [value, setValue] = useState({
    FirstName: "",
    LastName: "",
    EmailID: "",
    RegMobileNo: verifiedMobile,
  });

  useEffect(() => {
    if (!auth?.Astro) {
      navigate("/astrologer-register", { replace: true });
      return;
    }
    const mobile = auth?.MobileNo || auth?.Mobile || "";
    if (mobile) {
      setValue((prev) => ({ ...prev, RegMobileNo: mobile }));
    }
  }, [auth?.Astro, auth?.MobileNo, auth?.Mobile, navigate]);

  useEffect(() => {
    if (!popupStatus) return;
    const timer = setTimeout(() => {
      setPopupStatus(false);
      clearAuthData();
      window.location.href = "https://astrocall.live/";
    }, 5000);
    return () => clearTimeout(timer);
  }, [popupStatus]);

  const handleChangeupdate = (e) => {
    const { name, value: val } = e.target;
    setValue((prev) => ({ ...prev, [name]: val }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const checkBasicValidation = () => {
    const newErrors = {};
    if (!value?.FirstName) newErrors.FirstName = "required *";
    if (!value?.LastName) newErrors.LastName = "required *";
    if (!value?.EmailID) newErrors.EmailID = "required *";
    else if (!emailRegex.test(value.EmailID)) newErrors.EmailID = "Invalid email address *";
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) Update_Astrologer_Basic();
  };

  const Update_Astrologer_Basic = () => {
    const { FirstName, LastName, EmailID } = value;
    const val = {
      FirstName,
      LastName,
      EmailID,
      AstroID: auth?.Astro,
    };
    setIsSubmitting(true);
    TokenWithDeleteUpadateAdd("Astrologer/UpdateAstrologerDetails", val)
      .then((res) => {
        if (res?.success === true) {
          setErrors({});
          setPopupStatus(true);
        } else {
          console.log(res, "error");
          toastifyError("Unable to save details. Please try again.");
        }
      })
      .catch((error) => {
        console.log(error, "error");
        toastifyError("Unable to save details. Please try again.");
      })
      .finally(() => setIsSubmitting(false));
  };

  const closeAndGoHome = () => {
    setPopupStatus(false);
    clearAuthData();
    window.location.href = "https://astrocall.live/";
  };

  const formCard = (
    <article className="ao-card ao-card--wide">
      <div className="ao-card__inner">
        <header className="ao-card__brand">
          <img src={logo} alt="AstroCall" width={52} height={52} className="ao-card__logo" />
          <p className="ao-card__name">AstroCall</p>
          <p className="ao-card__tag">Astrologer Registration</p>
        </header>

        <AstrologerProgress currentStep={2} mobileVerified />

        <h2 className="ao-step-title">Personal Information</h2>
        <p className="ao-step-sub">Tell us about yourself to get started</p>

        <div className="ao-grid-2">
          <div className="ao-field">
            <label htmlFor="FirstName" className="ao-label">
              First Name*
            </label>
            <input
              className="ao-input"
              type="text"
              name="FirstName"
              id="FirstName"
              placeholder="Enter First Name"
              maxLength={60}
              onChange={handleChangeupdate}
              value={value.FirstName}
              aria-invalid={!!errors.FirstName}
              aria-describedby={errors.FirstName ? "err-FirstName" : undefined}
            />
            {errors.FirstName && (
              <p className="ao-error" id="err-FirstName" role="alert">
                {errors.FirstName}
              </p>
            )}
          </div>

          <div className="ao-field">
            <label htmlFor="LastName" className="ao-label">
              Last Name*
            </label>
            <input
              className="ao-input"
              type="text"
              name="LastName"
              id="LastName"
              placeholder="Enter Last Name"
              maxLength={60}
              onChange={handleChangeupdate}
              value={value.LastName}
              aria-invalid={!!errors.LastName}
              aria-describedby={errors.LastName ? "err-LastName" : undefined}
            />
            {errors.LastName && (
              <p className="ao-error" id="err-LastName" role="alert">
                {errors.LastName}
              </p>
            )}
          </div>

          <div className="ao-field ao-field--full">
            <label htmlFor="EmailID" className="ao-label">
              Email Address*
            </label>
            <input
              className="ao-input"
              type="email"
              name="EmailID"
              id="EmailID"
              placeholder="Enter Email Address"
              onChange={handleChangeupdate}
              value={value.EmailID}
              aria-invalid={!!errors.EmailID}
              aria-describedby={errors.EmailID ? "err-EmailID" : undefined}
            />
            {errors.EmailID && (
              <p className="ao-error" id="err-EmailID" role="alert">
                {errors.EmailID}
              </p>
            )}
          </div>

          <div className="ao-field ao-field--full">
            <label htmlFor="RegMobileNo" className="ao-label">
              Registered Mobile Number*
            </label>
            <div className="ao-phone ao-phone--locked">
              <div className="ao-phone__code">+91</div>
              <input
                className="ao-input"
                type="text"
                name="RegMobileNo"
                id="RegMobileNo"
                readOnly
                disabled
                placeholder="Registered Mobile Number"
                value={formatIndianPhoneNumber(value.RegMobileNo || verifiedMobile).replace("+91 ", "")}
                aria-readonly="true"
              />
              <span className="ao-phone__lock" aria-hidden>
                <FaLock size={12} />
              </span>
            </div>
            <p className="ao-hint">Verified mobile number — cannot be changed</p>
          </div>
        </div>

        <div className="ao-actions">
          <button
            type="button"
            className="ao-btn ao-btn--secondary"
            onClick={() => navigate("/astrologer-register")}
          >
            Back
          </button>
          <button
            type="button"
            className="ao-btn ao-btn--primary"
            disabled={isSubmitting}
            onClick={checkBasicValidation}
          >
            {isSubmitting ? "Submitting..." : "Submit →"}
          </button>
        </div>
      </div>
    </article>
  );

  const successModal = popupStatus ? (
    <div className="ao-modal-overlay">
      <div className="ao-modal" role="dialog" aria-modal="true" aria-labelledby="success-title">
        <div className="ao-modal__brand">
          <img src={logo} alt="AstroCall" width={40} height={40} />
          <h2 style={{ color: "#f97316" }}>AstroCall</h2>
        </div>
        <div className="ao-modal__icon">
          <FaCheck />
        </div>
        <h3 className="ao-modal__title" id="success-title">
          Thank You!
        </h3>
        <p className="ao-modal__text">
          Your information has been successfully submitted on AstroCall. Our team will contact you shortly.
        </p>
        <button type="button" className="ao-btn ao-btn--primary ao-btn--block mt-6" onClick={closeAndGoHome}>
          Close
        </button>
      </div>
    </div>
  ) : null;

  return (
    <AstrologerOnboardingLayout
      marketing={<AstrologerMarketingPanel />}
      formCard={formCard}
      modal={successModal}
    />
  );
}
